import { useEffect, useRef, useState } from "react";
import { trans } from "utils/helpers";
import { getFeedApiDictionaryApi } from "./api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { ICON_TYPE } from "utils/constants";
import { ModalForm } from "components/ModalForm/ModalForm";
import { FeedApiForm } from "./FeedApiForm";
interface FeedApiPropsType {

  resetForm?: boolean,
  required?: boolean,
  returnObj?: boolean,
  disable?: boolean,
  value?: string,
  mode?: string,
  ApiSelectedList?: any,
  name: string,
  FeedApiListCallback?: (e) => void,
}

export const FeedApi = ({  value,mode,disable= false,returnObj=false,ApiSelectedList ,resetForm,required , name="" ,FeedApiListCallback}: FeedApiPropsType) => {
  const [FeedApi, setFeedApis] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat , setValidat] = useState(false);
  const [rquird , setRquird] = useState(false);
  const [showFeedApiForm , setShowFeedApiForm] = useState(false);
  const [count,setCount] = useState<number>(0);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const [disabled, setDisabled] = useState(mode == "view" ? true : false);
  const [selectedItem, setSelectedItem] = useState<any>([]);

  const countRef = useRef<any>(0)


  async function getFeedApiListAsync(search?, id?) {
    try {
      const res = await getFeedApiDictionaryApi(search, id);
      setFeedApis(res.data.Data)
      setShow(true)
      setFlag(!flag)
    } catch (err: any) {
      
    }
  }


  const Auto = (e) => {
    setValidat(false)
    setRquird(false)
    setShow(true)
    getFeedApiListAsync(e.target.value, "")
    setFlag(!flag)
  }
  const resetData = (e) => {
    setValidat(false)
    setRquird(false)
    setShow(true)
    inputRef.current.value = null
    inputIdRef.current.value = null
    getFeedApiListAsync(null, "")
    setFlag(!flag)
  }

  function userSelecter(){
   // setValeu(options_PostLevel_values[countRef.current],options_PostLevel_keys[countRef.current])

    setShow(false)
  }

  const kydown = (event) => {  

    if((event.key === "ArrowDown")){
      if(countRef.current < FeedApi.length-1){
        countRef.current = countRef.current + 1;
      }else{
        countRef.current = 0;
      }
    }
    
    if(event.key === "ArrowUp"){
      if(countRef.current > 0){
        countRef.current = countRef.current -1;
      }else{
        countRef.current = FeedApi.length-1;
      }
    }
    document.getElementById("FeedApiIndex"+countRef.current)?.scrollIntoView({block:'end',behavior:"smooth"})
    setCount(countRef.current)
    if(event.key === "Enter"){
      userSelecter()
    }
  }

  const CheckFeedApi =async (e)=>{
    setTimeout(async() => {
      if(e.target.value.length == 0&& inputRef.current?.value?.length == 0 && e.target.value==""){
        inputIdRef.current.value = null
        if(required)
        setRquird(true)
    }else{
      setRquird(false)
      try{
        const res = await getFeedApiDictionaryApi(e.target.value,"")
        if(Object.keys(res).length==0){
          setValidat(true)
        }
        if(Object.keys(res).length == 1){
          setValeu(Object.values(res)[0],  Object.keys(res)[0]   )
        }
      }catch(err:any){
        setValidat(true)
      }
    }
    }, 200);
    await delay(200)
    if(!document.activeElement?.className.includes("")){
      setShow(false)
   }
  }

  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));


  const setValeu = (item, id) => {
    if(inputIdRef != null && inputIdRef.current != null){
      setRquird(false)
      inputRef.current.value = item.Title
      inputIdRef.current.value = id
      setFeedApis(null)
      setFlag(!flag)
    }
  }

  
  useEffect(() => {
    if (value) {
      getFeedApiListAsync(null, value)
    }
  }, [value ,resetForm]);

  
  useEffect(() => {
      setDisabled(mode == "view" ? true : false)
    
  }, [mode]);


  useEffect(() => {
    if(ApiSelectedList){

      setSelectedItem(ApiSelectedList)
    }
    
  }, [ApiSelectedList]);
  function clickToclose(e){
    let input = document.querySelector("#browser"+name);
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }
  async function deleteaOption(obj , index) {
      let list = selectedItem
      list.splice(index,1)
      FeedApiListCallback&&  FeedApiListCallback(list)
      setSelectedItem(list)
    
}

  function addOption(e) {
    e.stopPropagation()
    e.preventDefault()
    let Name = inputRef.current.value 
    let Id = inputIdRef.current.value

    if(FeedApiListCallback){
      let selectList = JSON.parse(JSON.stringify(selectedItem))
      FeedApiListCallback([...selectList, {Id:Id , Name:Name}])
      setSelectedItem(selectList.concat({Id:Id , Name:Name}))
    }else{ }
}

  function addNewFeedApi(e) {
    e.stopPropagation()
    e.preventDefault()
    setShowFeedApiForm(true)
  }

  useEffect(() =>{
    if(show){
      document.addEventListener('keydown', kydown);
      document.body.addEventListener("click", clickToclose)

    } 
    return () => { document.removeEventListener("keydown", kydown);document.body.removeEventListener('click', clickToclose) }

    
  },[show ])


  return (
    <>
      <ModalForm mode={mode} title="FeedApi"  onHide={() => setShowFeedApiForm(false)} show={showFeedApiForm}>
        <FeedApiForm 
         
         mode={"create"}
         onHide={()=>{setShowFeedApiForm(false)}}
         reset={resetData}
        />
      </ModalForm>

      <div className="text-box">
        <label htmlFor="browser" className="text-box__label">{trans("FeedApi")}</label>
        {required && <span className="text-box__required-sign-for-label text-danger">*</span>}
        <input required={required} defaultValue={value}   name={name} className="d-none" ref={inputIdRef} />
        <>
        <form style={{display:"flex" , alignItems:'end' ,flexDirection:"row",width:"100%"}}  >
              <div style={{width:"99%"}} >
               <input required={required}  autoFocus={valueName} defaultValue={valueName}  onBlur={CheckFeedApi} autoComplete="off" onMouseDown={(e) => {e.stopPropagation(); Auto(e) }} onFocus={() => {getFeedApiListAsync( valueName); setShow(true) }} ref={inputRef} list="FeedApiList" name="browser" className={"text-box__box form-control" + " browser"+name} type={'text'} id={"browser"+name} onChange={Auto} disabled={disable? disable :  disabled} />
              {
                show &&
                <div className={`text-box__sub-menu mt-1 glassBox border border-1`} tabIndex={-1} >    
                  {FeedApi&&FeedApi.map((item, index) => {

                    return(
                      <div id={"FeedApiIndex"+index} className={`border-bottom ${count == index ?"text-box__sub-menu-option-active" : "text-box__sub-menu-option"}`} onClick={(e) => { setValeu(item, item.Id);addOption(e) }} key={item.Id} >
                        <div id={"PositionIndex"+index} className={`font-size-md `} >{item.Title}</div>
                        <div className="mt-1 font-size-sm text-muted">{item.FeedApiUrl}</div>
                      </div>
                    )
                  })}
                </div>
                 }                
              </div>
              {!disable&&
              <>
                <div  style={{marginTop:"4px" , width:"10%"}}>
                  <Button Icon={true}  value={<button onClick={addOption} className="checkButton" > <FontAwesomeIcon icon={[ICON_TYPE, "check"]}    size="2x"  /></button>} btnType="submit"  />
                </div>
                <div style={{marginTop:"4px" , width:"10%"}} className="me-2">
                  <Button Icon={true}  value={<button onClick={addNewFeedApi} className="checkButton" > <FontAwesomeIcon icon={[ICON_TYPE, "plus"]}    size="2x"  /></button>} btnType="primary"  />
                </div>
              </>


              }
             </form>
             <div className="group-person__selected-options-wrapper">
              { selectedItem.map((item, index) => (
            <div className="group-person__selected-option form-control-custom" key={item.Id + index}>
                <div className="group-person__defult-selected-option" data-key={item.Id}>
                   
                </div>
                <div className="showDots">
                 {trans(item.Name) } 
                </div>
                
                <div className="group-person__delete-selected-option" data-key={item.Id} onClick={()=>{deleteaOption(item, index)}}>
                    <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                </div>
            </div>
             ))}
           </div>      

        </>
      </div>
    </>
  )
}